<script>
import { connectInfiniteHits } from "instantsearch.js/es/connectors";
import { createWidgetMixin } from "vue-instantsearch/vue3/es";
import HolidayVillageIcon from "@/components/svg-icons/HolidayVillageIcon.vue";
import LocalActivityIcon from "@/components/svg-icons/LocalActivityIcon.vue";
import MedicalServicesIcon from "@/components/svg-icons/MedicalServicesIcon.vue";
import SuitcaseIcon from "@/components/svg-icons/SuitcaseIcon.vue";
import SupportAgentIcon from "@/components/svg-icons/SupportAgentIcon.vue";

export default {
  mixins: [createWidgetMixin({ connector: connectInfiniteHits })],
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible && !this.state.isLastPage) {
        this.state.showMore();
      }
    },
  },
  computed: {
    searchIsLoading() {
      return (
        this?.state?.instantSearchInstance?.status === "loading" ||
        this?.state?.instantSearchInstance?.status === "stalled"
      );
    },
    searchIsError() {
      return this?.state?.instantSearchInstance?.status === "error";
    },
  },
};
</script>

<script setup>
import NoResultsPage from "@/components/NoResultsPage.vue";
import Spinner from "@/components/helpers/Spinner.vue";
import InternshipCard from "../ResultCards/InternshipCard";
import { vElementVisibility } from '@vueuse/components';
import { useApplicationProgress } from "@/components/ExperiencePage/Algolia/composables.js";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { useStore } from "vuex";
import { API_ENTITY_INFORMATION } from "@/constants.ts";
import {
  getInternshipRedirectUrl
} from "../ResultCards/InternshipCard/utils";

const router = useRouter();
const store = useStore();
const redirectToViewPage = (program) => {
  router.push(getInternshipRedirectUrl(program));
};

const { onApplyClicked } = useApplicationProgress();

const handleApplyClicked = (hit) => {
  onApplyClicked({
    program_page: hit?.program_page,
    session: hit?.session,
    internshipId: hit?.internship?.id,
  });
};

const domainEntityId = computed(() => store.getters.getDomainEntityId || API_ENTITY_INFORMATION.id);
</script>

<template>
  <div v-if="state">
    <div v-if="searchIsLoading && !state.hits.length > 0">
      <Spinner class="relative h-50-screen" />
    </div>
      <div v-if="state.hits.length > 0">
        <div
        class="justify-items-left grid grid-cols-1 1/2lg:grid-cols-2 1/2xl:grid-cols-3 2xl:grid-cols-4 gap-x-10 lg:px-10 text-sm text-indigo-base">
          <div data-testid="whats-included" class="font-montserrat text-indigo-base font-weight: bold"><b>WHAT'S INCLUDED</b></div>
          <div class="icon-list col-span-full m-0" >
            <div class="icon-item">
              <SuitcaseIcon class="icon" />
              <span class="text">Career Coaching & Career Hub</span>
            </div>
            <div class="icon-item">
              <HolidayVillageIcon class="icon" />
              <span class="text">Housing*</span>
            </div>
            <div class="icon-item">
              <MedicalServicesIcon class="icon" />
              <span class="text">Medical Insurance*</span>
            </div>
            <div class="icon-item">
              <LocalActivityIcon class="icon" />
              <span class="text">On-site Activities & Excursions*</span>
            </div>
            <div class="icon-item">
              <SupportAgentIcon class="icon" />
              <span class="text">24/7 Support*</span>
            </div>
          </div>

      </div>
      <div class="flex justify-end w-full lg:px-10">
        <div class="text-xs text-indigo-base">*In-Person or Hybrid Internships Only</div>
      </div>
      <div
        class="justify-items-center grid grid-cols-1 1/2lg:grid-cols-2 1/2xl:grid-cols-3 3xl:grid-cols-4 gap-x-10 gap-y-12 lg:px-10 pb-18">
        <InternshipCard v-for="hit in state.hits" :key="hit.objectID"
          class="internship-program-card flex flex-col max-w-[440px] min-w-[320px]" :hit="hit"
          :domain-entity-id="domainEntityId"
          @apply-clicked="handleApplyClicked(hit)" @view-clicked="redirectToViewPage(hit)" />
        <div v-element-visibility="[visibilityChanged]" />
      </div>
    </div>
    <Spinner v-if="searchIsLoading && state.hits.length > 0" outer-classes="" />
    <div v-else-if="!searchIsLoading && !state.hits.length > 0">
      <NoResultsPage margin-top="mt-5" />
    </div>
  </div>
</template>

<style scoped>
.icon-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}

@media (max-width: 768px) {
  .icon-list {
    flex-direction: column; /* Switch to vertical layout on mobile screens */
    gap: 16px; /* Adjust gap for smaller screens */
    align-items: flex-start;
  }
}

.icon-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
}

.icon {
  width: 40px;
  height: 40px;
}

.text {
  margin-top: 8px;
  margin-left: 8px;
}
</style>

